type Props = {
  on: boolean;
  onChange: (next: boolean) => void;
  label?: string;
};

export function Toggle({ on, onChange, label }: Props) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      aria-label={label}
      className={`tcg-toggle ${on ? "on" : ""}`}
      onClick={() => onChange(!on)}
    >
      <span className="tcg-toggle-knob" />
    </button>
  );
}
